import React from 'react';
import { useReveal } from '../lib/useReveal';
const PAIN_POINTS = ['Años sintiendo el llamado sin dar el paso', 'Cursos sueltos que no conectan entre sí', 'Sin certificado oficial que respalde lo que sabés', 'Protocolos de sintonización que nadie te enseñó paso a paso', 'Querés enseñar pero no sabés cómo iniciar a tus alumnos', 'Podés cobrar por esto pero no tenés la estructura para animarte'];
export function ProblemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#f3e9f7] py-12 md:py-16 px-5 sm:px-6 relative overflow-hidden border-t border-[#e8d5f0]" data-id="element-345">
      <div className="container mx-auto max-w-3xl relative z-10" data-id="element-346">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-347">
          <div className="text-center mb-10" data-id="element-348">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight text-[#3d2a5f]" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-349">
              ¿Cuánto tiempo más vas a postergar esto?
            </h2>
            <div className="text-lg md:text-xl text-[#6b5a85] space-y-4 font-medium" data-id="element-350">
              <p data-id="element-351">
                Sentís el llamado del Reiki hace tiempo. Tal vez años. Pero
                nunca encontraste una formación completa, seria y accesible en
                Argentina.
              </p>
              <p className="text-[#c9a14d] font-bold" data-id="element-352">
                No es falta de vocación. Es falta de un sistema.
              </p>
            </div>
          </div>

          <div className="max-w-2xl mx-auto bg-white border border-[#e8d5f0] rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-353">
            <ul className="space-y-4" data-id="element-354">
              {PAIN_POINTS.map((point, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-355">
                  <span className="text-red-400 text-lg leading-none mt-0.5 flex-shrink-0" data-id="element-356">
                    ❌
                  </span>
                  <span className="text-[#3d2a5f] text-base md:text-lg leading-snug font-medium" data-id="element-357">
                    {point}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="mt-10 text-center" data-id="element-358">
            <p className="text-[#3d2a5f] font-serif italic text-xl md:text-2xl font-bold" data-id="element-359">
              ¿Y si este fuera el último día que postergás tu camino?
            </p>
          </div>
        </div>
      </div>
    </section>;
}